// src/components/SchemeModal.jsx
import React, { useEffect, useMemo, useRef } from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import './schemeModal.scss';

export default function SchemeModal({ open, items, index, onClose, onChangeIndex }) {
  const overlayRef = useRef(null);

  const hasPrev = index > 0;
  const hasNext = index < items.length - 1;

  const current = useMemo(() => items?.[index] || null, [items, index]);

  useEffect(() => {
    if (!open) return;

    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
      if (e.key === "ArrowLeft" && hasPrev) onChangeIndex?.(index - 1);
      if (e.key === "ArrowRight" && hasNext) onChangeIndex?.(index + 1);
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, index, hasPrev, hasNext, onClose, onChangeIndex]);

  if (!open || !current) return null;

  return (
    <div
      className="scheme-modal"
      ref={overlayRef}
      onMouseDown={(e) => {
        if (e.target === overlayRef.current) onClose?.();
      }}
    >
      <div className="scheme-modal__top">
        <div className="scheme-modal__title">
          {current.title}{" "}
          <span className="scheme-modal__counter">
            {index + 1}/{items.length}
          </span>
        </div>

        <button className="scheme-modal__close" type="button" onClick={onClose}>
          ✕
        </button>
      </div>

      <button
        type="button"
        className={"scheme-modal__nav scheme-modal__nav--left" + (hasPrev ? "" : " is-disabled")}
        onClick={() => hasPrev && onChangeIndex(index - 1)}
        aria-label="Prev"
      >
        ‹
      </button>

      <div className="scheme-modal__content">
        <TransformWrapper
          initialScale={1}
          minScale={1}
          maxScale={6}
          centerOnInit
          wheel={{ step: 0.15 }}
          doubleClick={{ mode: "zoomIn", step: 0.8 }}
          pinch={{ step: 5 }}
        >
          <TransformComponent
            wrapperStyle={{ width: "100%", height: "100%" }}
            contentStyle={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img className="scheme-modal__img" src={current.full} alt={current.title} />
          </TransformComponent>
        </TransformWrapper>
      </div>

      <button
        type="button"
        className={"scheme-modal__nav scheme-modal__nav--right" + (hasNext ? "" : " is-disabled")}
        onClick={() => hasNext && onChangeIndex(index + 1)}
        aria-label="Next"
      >
        ›
      </button>
    </div>
  );
}
